// extracted by mini-css-extract-plugin
export default {"chapter":"BookChapter_chapter__5CygQ","chapterTitle":"BookChapter_chapterTitle__jvHoC","fadeIn":"BookChapter_fadeIn__JdzuA","visible":"BookChapter_visible__S6RRN"};